import template from './user-display.html';
import controller from './user-display.controller';
import './user-display.css';

const UserDisplayComponent = {
    template,
    controller,
    bindings: {
        user: '<',
        avatarSize: '<',
        fontSize: '<',
        containerSelector: '@',
        avatarOnly: '<',
        modalOpened: '&',
        hasLink: '<'
    },
};

export default UserDisplayComponent;



// WEBPACK FOOTER //
// ../widgets/user-display/user-display.component.js